<template>
  <v-card-text v-if="!success">
    <v-form v-model="valid">
      <v-text-field
        filled
        v-model="whoAnnounced"
        type="text"
        label="Το όνομα σας"
      >
      </v-text-field>
      <v-textarea
        filled
        :rules="rules"
        label="περιγραφή βλάβης"
        v-model="description" 
      >
      </v-textarea>
      <v-btn color="callout" :disabled="!valid" @click="newCallout()" large dark
        >ΑΠΟΣΤΟΛΗ ΒΛΑΒΗΣ
      </v-btn>
    </v-form>
  </v-card-text>
  <v-card-text v-else class="text-center">
    <v-icon color="green" size="100">mdi-check</v-icon>
    <h2>Η βλάβη στάλθηκε στο γραφείo.</h2>
  </v-card-text>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "CalloutForm",
  data: () => ({
    valid: false,
    success: false,
    whoAnnounced:"",
    description: "",
    rules: [(v) => !!v || "Δεν έχει συμπληρωθεί το πεδίο"],
  }),

  computed: {
    ...mapGetters(["userDetails", "branch"]),
  },
  methods: {
    ...mapActions(["addCallout"]),
    newCallout() {
      this.addCallout({
        Partner_ID: this.partner_id,
        Contact_ID: this.userDetails.Contact_ID,
        Branch_ID: this.branch_id,
        Project_ID: this.project_id,
        WhoAnnounced: this.whoAnnounced,
        CalloutDescription: this.description,
        Stopped: false, 
      }).then((resp) => {
        this.success = true;
        setTimeout(() => {
          this.$emit("calloutAdded");
          this.success = false;
        }, 1000);
      });
    },
  },
  props: {
    partner_id: { type: Number, default: null, required: false },
    branch_id: { type: Number, default: null, required: false },
    project_id: { type: Number, default: null, required: false },
  },
};
</script>

<style scoped>
</style>
